import React from "react";
import { useTranslation } from "react-i18next";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/sonner";
import { DoctorChatAssistant } from "@/components/chat/DoctorChatAssistant";
import { useLocation } from "react-router-dom";

export function Layout({ children }) {
    const { t } = useTranslation();
    const { pathname } = useLocation();

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);

    return (
        <div className="App">
            <a
                href="#main"
                className="sr-only focus:not-sr-only focus:fixed focus:z-[100] focus:top-2 focus:left-2 rounded bg-white px-3 py-1.5 text-sm shadow"
            >
                {t("common.skipToContent")}
            </a>
            <Header />
            <main id="main" data-testid="main-content" className="min-h-[60vh]">
                {children}
            </main>
            <Footer />
            <DoctorChatAssistant />
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}
